'use client'

import FullPageLoader from '@/app/_components/Page/FullPageLoader';
import { Login } from '@components/Page/Login'
import { signIn } from "next-auth/react"
import { useState } from 'react';

export default function Page() {

    const [loading, setLoading] = useState(false);

    return loading ? (
        <>
            <FullPageLoader />
        </>
    ) : (
        <>
            <Login
                onLogin={(email: string, password: string, otp: string) => {
                    setLoading(true);
                    signIn('credentials', { email, password, otp, callbackUrl: '/' })
                }}
                onLoginError={(error: any, data: any) => {
                    setLoading(false);
                    console.log('Login error', error, data);
                }}
            />
        </>
    )
}
